import { render, staticRenderFns } from "./SP.vue?vue&type=template&id=06e4a73d&"
import script from "./SP.vue?vue&type=script&lang=js&"
export * from "./SP.vue?vue&type=script&lang=js&"
import style0 from "./SP.vue?vue&type=style&index=0&id=06e4a73d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports